import React, { useEffect, useState } from "react";
import MavTabs from "./MavTabs";
import MavRisk from "./MavRisk";
import MavDevices from "./MavDevices";
import moment from "moment";
import { DatePicker, Space } from "antd";
import { getChildTopRisks, getChildViewSummary, getChildList, getChildScanReport, getChildDailyScans } from "../../store/service";
import { Notification } from "../common/Notification";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";

function MobileAttackView(props: any) {
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const [selectedTab, setSelectedTab] = useState("1");
    const [date, setDate] = useState({
        startDate: moment().startOf("month"),
        endDate: moment().endOf("month"),
    });
    let { tabName } = props.match.params;

    useEffect(() => {
        if (tabName === "risk") {
            setSelectedTab("1");
        }
        if (tabName === "devices") {
            setSelectedTab("2");
        }
    }, [tabName]);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [routeLoading]);

    const onDateChange = (dates: any) => {
        if (dates) {
            setDate({
                startDate: moment(dates).startOf("month"),
                endDate: moment(dates).endOf("month"),
            });
        }
    };
    const [loading, setLoading] = useState<boolean>(true);
    const [summaryLoading, setSummaryLoading] = useState<boolean>(true);
    const [riskLoading, setRiskLoading] = useState<boolean>(true);
    const [scanLoading, setScanLoading] = useState<boolean>(true);
    const [childTopRisks, setChildTopRisks] = useState([]);
    const [childScanReport, setChildScanReport] = useState([]);
    const [childSummary, setChildSummary] = useState<any>(null);
    const [data, setData] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [isError, setIsError] = useState(false);
    useEffect(() => {
        if (date && date.startDate && date.endDate) {
            const reqData = {
                startDate: moment(date.startDate).format("YYYY-MM-DD"),
                endDate: moment(date.endDate).format("YYYY-MM-DD"),
            };
            setLoading(true);
            setRiskLoading(true);
            setScanLoading(true);
            setSummaryLoading(true);
            setIsError(false);
            getChildViewSummary(reqData)
                .then((res) => {
                    setSummaryLoading(false);
                    setLoading(false);
                    if (res.isSuccess) {
                        setChildSummary(res);
                        getChildTopRisks(reqData)
                            .then((resp) => {
                                setRiskLoading(false);
                                if (resp.isSuccess) {
                                    setChildTopRisks(resp.childTopRisks);
                                } else {
                                    setChildSummary(null);
                                    setChildTopRisks([]);
                                }
                            })
                            .catch((err: any) => {
                                setRiskLoading(false);
                                setChildSummary(null);
                                Notification({
                                    type: "error",
                                    title: "Error",
                                    message: err,
                                    duration: 5,
                                });
                            });
                        getChildDailyScans(reqData)
                            .then((resp) => {
                                setScanLoading(false);
                                if (resp.isSuccess) {
                                    setChildScanReport(resp._childScans);
                                }
                            })
                            .catch((err: any) => {
                                setScanLoading(false);
                                setChildScanReport([]);
                                Notification({
                                    type: "error",
                                    title: "Error",
                                    message: err,
                                    duration: 5,
                                });
                            });
                    } else {
                        setChildSummary(null);
                        setChildTopRisks([]);
                        setChildScanReport([]);
                        setRiskLoading(false);
                        setScanLoading(false);
                    }
                })
                .catch((err: any) => {
                    setSummaryLoading(false);
                    setChildTopRisks([]);
                    setChildScanReport([]);
                    setLoading(false);
                    setRiskLoading(false);
                    setScanLoading(false);
                    setIsError(true);
                    Notification({
                        type: "error",
                        title: "Error",
                        message: err,
                        duration: 5,
                    });
                });
            getChildList({
                startDate: moment(date.startDate).format("YYYY-MM-DD"),
                endDate: moment(date.endDate).format("YYYY-MM-DD"),
            })
                .then((res) => {
                    setLoading(false);
                    if (res.isSuccess) {
                        const listData = res._childLists.reduce((a: any, b: any) => {
                            a.push(...b.devices);
                            return a;
                        }, []);

                        setData(listData);
                        getChildScanReport({
                            startDate: moment(date.startDate).format("YYYY-MM-DD"),
                            endDate: moment(date.endDate).format("YYYY-MM-DD"),
                        })
                            .then((resp) => {
                                if (resp.isSuccess) {
                                    setReportData(resp.childScanReportList);
                                } else {
                                    setReportData([]);
                                }
                            })
                            .catch((err) => {
                                setIsError(true);
                                Notification({
                                    type: "error",
                                    title: "Error",
                                    message: err,
                                    duration: 5,
                                });
                            });
                    } else {
                        setData([]);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    setIsError(true);
                    setData([]);
                    Notification({
                        type: "error",
                        title: "Error",
                        message: err,
                        duration: 5,
                    });
                });
        }
    }, [date]);
    const disabledDate = (current: any) => {
        if (current) {
            if (current < moment().endOf("day") && current > moment().subtract(10, "years").endOf("day")) {
                return false;
            }
        }
        return true;
    };

    return (
        <div>
            <div className="row">
                <div className="col-xs-12 ml-1">
                    <h1 className="title-page">Mobile Attack View</h1>
                </div>
            </div>

            <div className="row" id="content">
                <div className="col-xs-12">
                    {selectedTab === "1" && <MavTabs selectedTab="1" />}
                    {selectedTab === "2" && <MavTabs selectedTab="2" />}
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 flex-end mav-date-picker flex-center">
                    <h5 className="padding-right-l">Date Range</h5>
                    <Space direction="vertical">
                        <DatePicker
                            format="MM/YYYY"
                            picker="month"
                            defaultValue={moment().startOf("month")}
                            disabledDate={disabledDate}
                            style={{ width: 150 }}
                            onChange={onDateChange}
                        />
                    </Space>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    {(tabName === "risk" || selectedTab === "1") && (
                        <MavRisk
                            childSummary={childSummary}
                            childTopRisks={childTopRisks}
                            summaryLoading={summaryLoading}
                            riskLoading={riskLoading}
                            scanLoading={scanLoading}
                            childScanReport={childScanReport}
                            isError={isError}
                        />
                    )}
                    {tabName === "devices" && <MavDevices loading={loading} data={data} date={date} reportData={reportData} isError={isError} />}
                </div>
            </div>
        </div>
    );
}

export default MobileAttackView;
